import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Tier, volumeIncludes, volumes } from '../data/content';
const tierAccent: Record<Tier, string> = {
  minis: 'border-l-emerald-500',
  infantil: 'border-l-sky-500',
  menores: 'border-l-violet-500',
  juveniles: 'border-l-orange-500',
  mayores: 'border-l-accent'
};
export function Volumes() {
  return <section className="border-b border-line bg-ink-800 py-16 md:py-24" aria-labelledby="volumes-title" data-id="element-207" data-mp="1c3e53i2dx4wt">
      <div className="mx-auto max-w-6xl px-5 md:px-8" data-id="element-208" data-mp="1zt8etqreqdcu">
        <h2 id="volumes-title" className="font-display text-4xl font-extrabold uppercase text-white md:text-6xl" data-id="element-209" data-mp="24surnz3bprl4">
          The 15 Complete Volumes
        </h2>

        <ol className="mt-10 grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-210" data-mp="1vserayhvn0kh">
          {volumes.map(volume => <li key={volume.number} className={`flex h-full flex-col rounded-lg border border-line border-l-4 bg-ink p-5 ${tierAccent[volume.tier]}`} data-id="element-211" data-mp="feeuhwebvr1g">
              <p className="font-display text-lg font-bold uppercase leading-tight text-white" data-id="element-212" data-mp="3o981qssh50w4">
                <span aria-hidden="true" data-id="element-213" data-mp="3ja54huiqjyyp">{volume.dot}</span> Volume {volume.number} —{' '}
                {volume.title}
              </p>
              <p className="mt-1 text-xs font-semibold uppercase tracking-wide text-slate-400" data-id="element-214" data-mp="1yvnift59a33">
                {volume.ages}
              </p>
              <p className="mt-3 text-sm font-semibold text-accent" data-id="element-215" data-mp="b0v5babzgi73">{volume.weeks}</p>
              <p className="mt-auto pt-3 text-sm leading-relaxed text-slate-300" data-id="element-216" data-mp="62tpqzdrn10d">{volume.topics}</p>
            </li>)}
        </ol>

        <div className="mt-14 rounded-xl border border-line bg-ink p-6 md:p-10" data-id="element-217" data-mp="kqwts38902mj">
          <h3 className="font-display text-2xl font-extrabold uppercase tracking-wide text-white md:text-3xl" data-id="element-218" data-mp="ftehq3yxp7ab">
            What every volume includes
          </h3>
          <ul className="mt-6 grid gap-x-8 gap-y-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-219" data-mp="pqj4a4woz4rn">
            {volumeIncludes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-slate-200 md:text-base" data-id="element-220" data-mp="wusfj74qhxik">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-emerald-400" aria-hidden="true" data-id="element-221" data-mp="11tvmix49ydt6" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}